import { useNavigate } from 'react-router-dom';
import BorderColorIcon from '@mui/icons-material/BorderColor';
import CardAction from '../../../components/card/CardAction';
import { filterUndefined } from '../../../utils/FilterUndefinedObject';

/**
 * Copy Lesson Action Container
 */
const defaultProps = {
  className: '',
  goBackTo: null,
};

export default function EditLessonAction(props) {
  const mergedProps = { ...defaultProps, ...filterUndefined(props) };
  const { lesson, className, goBackTo } = mergedProps;
  const navigate = useNavigate();
  return (
    <CardAction
      icon={<BorderColorIcon aria-hidden='false' />}
      actionHandler={() => {
        navigate(`/lessons/${lesson.attributes.uuid}/update`,
          {
            state: {
              goBackTo,
            },
          });
      }}
      className={className}
      tabIndex={0}
      aria-hidden='false'
    />
  );
}
